// @flow

import Game from '@/lib/game';
import { SunTreeEvent, ShadeTreeEvent } from '@/lib/tutorial_event';

declare type TutrialMessage = {
  uid: string,
  priority: number,
  title: string,
  body: ?string,
};

export default class {
  game: Game;
  messages: TutrialMessage[];
  removed: TutrialMessage[];
  conditions: { isSatisfied(any): boolean, makeMessage(): TutrialMessage }[];

  constructor(game: Game) {
    this.game = game;
    this.messages = [];
    this.removed = [];
    this.conditions = [SunTreeEvent, ShadeTreeEvent];
  }

  process() {
    // 条件を満たしていれば次回評価対象から削除
    this.conditions = this.conditions.filter(condition => {
      if (condition.isSatisfied(this.game)) {
        const message = condition.makeMessage();

        // すでに表示済みのメッセージより優先度の低いチュートリアルは表示しない
        // 例). 種の購入を促すメッセージの後に木の伐採を促すメッセージを表示しない
        if (
          Math.max(...this.messages.map(m => m.priority)) < message.priority
        ) {
          this.messages.push(message);
        }

        return false;
      }

      return true;
    });
  }

  remove(uid: string) {
    const index = this.messages.findIndex(message => {
      return !!message && message.uid === uid;
    });

    if (Number.isInteger(index)) {
      this.removed.push(this.messages[index]);
      this.messages.splice(index, 1);
    }
  }
}



// WEBPACK FOOTER //
// ./src/lib/tutorial/tutorial.js